import { varieties } from '@/pages/cultivares/mock/varietySeeds'
import { countries } from '@/services/__mocks__/locationSeeds'
import { getCustomDate } from '@/utils/time'

const seeds = [
  {
    asset_owner_id: 1,
    ativo: null,
    ciclo: varieties[0].cycle,
    created_at: getCustomDate(-30),
    crop_cycle_id: varieties[0].cycle,
    crop_id: varieties[0].crop.id,
    cultivar: varieties[0].name,
    deleted_at: null,
    fcc: null,
    growth_habit_id: 1,
    grupo: '8.0',
    habito: null,
    icv: null,
    id: 1,
    inox: false,
    ogm: 'Sim',
    pais_id: countries[0].id,
    titular: null,
    updated_at: getCustomDate(-30),
  },
  {
    asset_owner_id: 2,
    ativo: null,
    ciclo: varieties[8].cycle,
    created_at: getCustomDate(-30),
    crop_cycle_id: varieties[8].cycle,
    crop_id: varieties[8].crop.id,
    cultivar: varieties[8].name,
    deleted_at: null,
    fcc: null,
    growth_habit_id: 2,
    grupo: '10.0',
    habito: null,
    icv: null,
    id: 2,
    inox: false,
    ogm: 'Sim',
    pais_id: countries[0].id,
    titular: null,
    updated_at: getCustomDate(-30),
  },
  {
    asset_owner_id: 3,
    ativo: null,
    ciclo: varieties[2].cycle,
    created_at: getCustomDate(-30),
    crop_cycle_id: varieties[2].cycle,
    crop_id: varieties[2].crop.id,
    cultivar: varieties[2].name,
    deleted_at: null,
    fcc: null,
    growth_habit_id: 3,
    grupo: '9.0',
    habito: null,
    icv: null,
    id: 3,
    inox: false,
    ogm: 'Sim',
    pais_id: countries[0].id,
    titular: null,
    updated_at: getCustomDate(-30),
  },
  {
    asset_owner_id: 4,
    ativo: null,
    ciclo: varieties[3].cycle,
    created_at: getCustomDate(-30),
    crop_cycle_id: varieties[3].cycle,
    crop_id: varieties[3].crop.id,
    cultivar: varieties[3].name,
    deleted_at: null,
    fcc: null,
    growth_habit_id: 4,
    grupo: '7.0',
    habito: null,
    icv: null,
    id: 4,
    inox: false,
    ogm: 'Sim',
    pais_id: countries[0].id,
    titular: null,
    updated_at: getCustomDate(-30),
  },
  {
    asset_owner_id: 5,
    ativo: null,
    ciclo: varieties[4].cycle,
    created_at: getCustomDate(-30),
    crop_cycle_id: varieties[4].cycle,
    crop_id: varieties[4].crop.id,
    cultivar: varieties[4].name,
    deleted_at: null,
    fcc: null,
    growth_habit_id: 5,
    grupo: '7.5',
    habito: null,
    icv: null,
    id: 5,
    inox: false,
    ogm: 'Sim',
    pais_id: countries[0].id,
    titular: null,
    updated_at: getCustomDate(-30),
  },
  {
    asset_owner_id: 6,
    ativo: null,
    ciclo: varieties[5].cycle,
    created_at: getCustomDate(-30),
    crop_cycle_id: varieties[5].cycle,
    crop_id: varieties[5].crop.id,
    cultivar: varieties[5].name,
    deleted_at: null,
    fcc: null,
    growth_habit_id: 6,
    grupo: '4.7',
    habito: null,
    icv: null,
    id: 6,
    inox: false,
    ogm: 'Sim',
    pais_id: countries[0].id,
    titular: null,
    updated_at: getCustomDate(-30),
  },
]

export { seeds }
